"use strict";Object.defineProperty(exports, "__esModule", {value: true});


var _XWMMMXUKcjs = require('./XWMMMXUK.cjs');


var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');

// src/form/form-context.tsx
var ctx = _PTOCUU2Dcjs.createStoreContext.call(void 0, 
  [_XWMMMXUKcjs.CollectionContextProvider],
  [_XWMMMXUKcjs.CollectionScopedContextProvider]
);
var useFormContext = ctx.useContext;
var useFormScopedContext = ctx.useScopedContext;
var useFormProviderContext = ctx.useProviderContext;
var FormContextProvider = ctx.ContextProvider;
var FormScopedContextProvider = ctx.ScopedContextProvider;







exports.useFormContext = useFormContext; exports.useFormScopedContext = useFormScopedContext; exports.useFormProviderContext = useFormProviderContext; exports.FormContextProvider = FormContextProvider; exports.FormScopedContextProvider = FormScopedContextProvider;
